// Shared modal chrome used by every Schedule modal. Extracted verbatim from
// pages/coach/Schedule.jsx (2026-06-08) as part of the P3 refactor.
import { X } from "lucide-react";

export function ModalShell({ children, onClose, testId, title }) {
    return (
        <div data-testid={testId} className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-zinc-950 border border-zinc-800 rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="px-6 py-4 border-b border-zinc-800 flex items-center justify-between">
                    <h3 className="text-lg font-semibold">{title}</h3>
                    <button type="button" onClick={onClose} className="text-zinc-200 hover:text-white">
                        <X className="w-5 h-5" />
                    </button>
                </div>
                <div className="p-6 space-y-4">{children}</div>
            </div>
        </div>
    );
}

export const Field = ({ label, children }) => (
    <label className="block">
        <span className="text-xs uppercase tracking-wider text-zinc-300">{label}</span>
        <div className="mt-1">{children}</div>
    </label>
);

export const inputClass =
    "w-full bg-zinc-900 border border-zinc-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-brand-red";
